import(/* webpackMode: "eager" */ "/app/apps/dtc-client/src/app/[lng]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dtc-client/src/components/analytics/braze.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsProvider"] */ "/app/apps/dtc-client/src/components/analytics/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dtc-client/src/components/datadog-connector.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.2.4_@babel+core@7.27.4_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/dist/client/script.js");
